<script setup>
import { ref } from 'vue';
import FilterItem from '../widgets/conversation/FilterItem.vue';

defineProps({
  accountStatusFilter: {
    type: String,
    default: 'active',
  },
});
const emit = defineEmits(['changeFilter']);

const showActionsDropdown = ref(false);
const accountStatusItems = ['active', 'suspended', 'all'];

function toggleDropdown() {
  showActionsDropdown.value = !showActionsDropdown.value;
}

function closeDropdown() {
  showActionsDropdown.value = false;
}

function onChangeFilter(value) {
  emit('changeFilter', value);
}
</script>

<template>
  <div class="relative flex">
    <woot-button
      v-tooltip.right="$t('CHAT_LIST.SORT_TOOLTIP_LABEL')"
      variant="smooth"
      color-scheme="secondary"
      class="selector-button"
      icon="sort-icon"
      @click="toggleDropdown"
    />
    <div
      v-if="showActionsDropdown"
      v-on-clickaway="closeDropdown"
      class="dropdown-pane dropdown-pane--open mt-4 right-0 basic-filter"
    >
      <div class="items-center flex justify-between">
        <span class="text-slate-800 dark:text-slate-100 text-xs font-medium">{{
          $t('CHAT_LIST.CHAT_SORT.STATUS')
        }}</span>
        <FilterItem
          type="status"
          :selected-value="accountStatusFilter"
          :items="accountStatusItems"
          path-prefix="SIDEBAR_ITEMS.ACCOUNT_STATUS_FILTER_ITEMS"
          @on-change-filter="onChangeFilter"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.basic-filter {
  @apply w-52 p-4 top-6;
}
</style>
